import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify);

const defaultLightTheme = {
  primary: colors.lightBlue.darken2,
};

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg",
  },
  theme: {
    themes: {
      light: defaultLightTheme,
    },
  },
});
